exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom_box[data-v-6498c568]{position:relative;height:100%}.custom_box-middle[data-v-6498c568]{max-height:500px;overflow:scroll;position:relative}.custom_box-bottom[data-v-6498c568]{width:100%}.custom_box-bottom p[data-v-6498c568]{padding:0 15px}", ""]);

// exports
